<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="编码">
      <a-input v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="名称">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <div style="text-align: right">
      <a-space>
      <a-button
        type="primary"
        v-if="!sysCodingRuleId" @click="onAdd" :disabled="form.disabled">
        {{ $t('CREATE') || '创建' }}
        <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
      </a-button>
      <a-button
        type="primary"
        v-if="sysCodingRuleId" @click="onUpdate" :disabled="form.disabled">{{ $t('UPDATE') || '创建' }}
        <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
      </a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </div>
  </a-form-model>
</template>

<script>
import {
  _querySysCodingRule,
  _addSysCodingRule,
  _updateSysCodingRule,
} from '@/api/sys/sysCodingRuleApi';

async function getSysCodingRule() {
  const result = await _querySysCodingRule(this.sysCodingRuleId);
  if (result) {
    this.form.data.code = result.sysCodingRule.code;
    this.form.data.name = result.sysCodingRule.name;
    this.form.data.review = result.sysCodingRule.review;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSysCodingRule({
        code: this.form.data.code,
        name: this.form.data.name,
        review: this.form.data.review,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  const result = await _updateSysCodingRule(this.sysCodingRuleId, {
    code: this.form.data.code,
    name: this.form.data.name,
    review: this.form.data.review,
  });
  if (result) {
    if (this.onSubmitHandler) {
      this.$message.success(this.$t('UPDATE_SUCCESS'));
      this.onSubmitHandler();
    }
  }
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'SysCodingRuleEdit',
  props: {
    sysCodingRuleId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sysCodingRuleId() {
      if (this.sysCodingRuleId) {
        this.getSysCodingRule();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getSysCodingRule,
  },
  data() {
    return {
      form: {
        data: {
          code: '',
          name: '',
          review: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sysCodingRuleId) {
      this.getSysCodingRule();
    }
  },
};
</script>
